if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {}
